import { html } from "lit";
import { renderStandardPictureElement } from "../../../../utils";

export const universalTeaserData = {
    media: "image",
    button: true,
    buttonType: "default",
    textAlignment: "center",
    highlight: false,
    text: "Visualisierung der zeitlichen Entwicklung von Umlaufbeständen an Arbeitsplätzen. Durch die neue Transparenz können Optimierungsmöglichkeiten der Bearbeitungsreihenfolge von Aufträgen in der Fertigung erkannt und umgesetzt werden.",
};

export const newsTeaserDataList = [
    {
        ...universalTeaserData,
    },
    {
        ...universalTeaserData,
        media: "image",
        text: "Visualisierung der Bearbeitungsreihenfolge von Aufträgen in der Fertigung erkannt und umgesetzt werden.",
    },
    {
        ...universalTeaserData,
        media: "image",
    },
    {
        ...universalTeaserData,
        media: "image",
    },
    {
        ...universalTeaserData,
        media: "video",
    },
    {
        ...universalTeaserData,
        media: "icon",
    },
];

export const TeaserUniversal = (args = universalTeaserData, gridClass) => html`
    <div class="ux-iws-teaser-universal ${gridClass}">
        <ux-iws-link-wrapper>
            <div
                class="ux-u-shadow ux-u-h-100 ux-u-d-flex ux-u-flex-dir-column"
            >
                <div class="ux-iws-teaser-universal__media">
                    ${args.media === "image"
                        ? html`${renderStandardPictureElement({
                              width: 708,
                              height: 472,
                          })}`
                        : html``}
                    ${args.media === "video"
                        ? html`<video controls>
                              <source
                                  src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                                  type="video/mp4"
                              />
                          </video>`
                        : html``}
                    ${args.media === "icon"
                        ? html`<ux-icon
                              name="info-rounded"
                              size-s="50"
                          ></ux-icon>`
                        : html``}
                </div>
                <div
                    class="ux-u-p-xs ux-u-d-flex ux-u-flex-dir-column ux-u-flex-jc-between ux-u-h-100"
                >
                    <div class="ux-u-text-align--${args.textAlignment}">
                        <div
                            class="${args.highlight
                                ? "ux-text-title ux-text-title--bold ux-text-title--green-square"
                                : "ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"}"
                        >
                            Analyse von Umlaufbeständen
                        </div>
                        <div class="ux-text-normal">
                            <p>${args.text}</p>
                        </div>
                    </div>
                    ${args.button
                        ? html`<div class="ux-u-text-align--center">
                              <a
                                  class="ux-button${args.buttonType ===
                                  "primary"
                                      ? " ux-button--primary"
                                      : ""}"
                                  >Button</a
                              >
                          </div>`
                        : html``}
                </div>
            </div>
        </ux-iws-link-wrapper>
    </div>
`;

export const TeaserUniversalTemplate = (args) => {
    return TeaserUniversal(args, "");
};

export const TeaserUniversalListTemplate = (args) => html`
    <div class="ux-row">
        ${newsTeaserDataList.map((tile) => {
            const gridClass = `ux-col-12 ${
                args.tilesPerRow === 2 ? "ux-col-md-6" : ""
            } ${
                args.tilesPerRow === 3 ? "ux-col-md-6 ux-col-lg-4" : ""
            } ux-u-mb-xs`;
            return TeaserUniversal(tile, gridClass);
        })}
    </div>
`;
